export interface TranslationKeys {
}

const en: TranslationKeys = {
}

export default en
